"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElasticResourceTypeToJSON = exports.ElasticResourceTypeFromJSONTyped = exports.ElasticResourceTypeFromJSON = exports.ElasticResourceType = void 0;
/**
 *
 * @export
 */
exports.ElasticResourceType = {
    NWG: 0,
    Scene7: 1,
    External: 2
};
function ElasticResourceTypeFromJSON(json) {
    return ElasticResourceTypeFromJSONTyped(json, false);
}
exports.ElasticResourceTypeFromJSON = ElasticResourceTypeFromJSON;
function ElasticResourceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ElasticResourceTypeFromJSONTyped = ElasticResourceTypeFromJSONTyped;
function ElasticResourceTypeToJSON(value) {
    return value;
}
exports.ElasticResourceTypeToJSON = ElasticResourceTypeToJSON;
